/**
 * /my-coaching/business/reading — Grow your practice. Every coach state sees
 * it: the list links to public pages, so there is nothing to lock. A revoked
 * coach goes to the dashboard, as the Marketing Suite page does.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

import { growPracticeQueryOptions } from "~/lib/queries/growPracticeQuery";

import { GrowPracticePage } from "./-components/grow-practice-page";

export const Route = createFileRoute("/_user/my-coaching/business/reading")({
  staticData: { title: "Reading" },
  beforeLoad: ({ context }) => {
    if (context.isRevoked) {
      throw redirect({ to: "/my-coaching/clients/dashboard" });
    }
  },
  loader: async ({ context }) => {
    const userId = context.user.clerkUserId;
    // Hands SSR the list; the page reads the same query and shows its own
    // failure and retry.
    await context.queryClient
      .ensureQueryData(growPracticeQueryOptions(userId))
      .catch(() => undefined);
    return { userId };
  },
  component: GrowPracticeRoute,
});

function GrowPracticeRoute(): React.JSX.Element {
  const { userId } = Route.useLoaderData();
  return <GrowPracticePage userId={userId} />;
}
